import { VALIDATION_MESSAGE } from '../ValidationMessage';
import yup from './CustomValidation/yup-extended';

export interface LiteracyScreeningDiagnosticMeasuresFormValues {
  phonemicAwareness: string[];
  phonics: string[];
  vocabulary: string[];
  oralLanguage: string[];
}

const hasDiagnosticSelection = (
  values?: LiteracyScreeningDiagnosticMeasuresFormValues
): boolean =>
  (values?.phonemicAwareness?.length || 0) +
    (values?.phonics?.length || 0) +
    (values?.vocabulary?.length || 0) +
    (values?.oralLanguage?.length || 0) >
  0;

export const LiteracyScreeningDiagnosticMeasuresValidationSchema = yup
  .object()
  .shape({
    phonemicAwareness: yup.array().of(yup.string()),
    phonics: yup.array().of(yup.string()),
    vocabulary: yup.array().of(yup.string()),
    oralLanguage: yup.array().of(yup.string()),
  })
  .test(
    'at-least-one-diagnostic-measure',
    VALIDATION_MESSAGE.LITERACY_SCREENING_DIAGNOSTIC_MEASURES_REQUIRED,
    (values) =>
      hasDiagnosticSelection(
        values as LiteracyScreeningDiagnosticMeasuresFormValues
      )
  );
